import React, { FC, MouseEvent, useEffect, useState } from 'react';
import { ThunderboltFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import cn from 'classnames';
import { IOpenAssistantOptions, isAssistantEnabled, onAssistantEnabledChange, openAssistant } from './launcher';
import styles from './styles.module.scss';

interface IAskButtonProps extends IOpenAssistantOptions {
    /** Button text. Defaults to "Ask Swiftlane". */
    label?: string;
    /** 'pill' for page headers, 'link' for inline row actions, 'sidebar' for the nav. */
    variant?: 'pill' | 'link' | 'sidebar';
    tooltip?: string;
    className?: string;
}

/** Entry point to the assistant from anywhere in the dashboard. Renders nothing
 * when the assistant is not enabled for this workspace. */
const AskButton: FC<IAskButtonProps> = ({ label = 'Ask Swiftlane', variant = 'pill', tooltip, className, prompt, send, entity }) => {
    const [enabled, setEnabled] = useState(isAssistantEnabled());
    useEffect(() => onAssistantEnabledChange(setEnabled), []);
    if (!enabled) return null;

    const onClick = (event: MouseEvent) => {
        event.stopPropagation();
        openAssistant({ prompt, send, entity });
    };
    const button = (
        <button
            type='button'
            className={cn(
                { [styles.askPill]: variant === 'pill', [styles.askLink]: variant === 'link', [styles.askSidebar]: variant === 'sidebar' },
                className,
            )}
            onClick={onClick}
        >
            <ThunderboltFilled />
            <span>{label}</span>
            {variant === 'sidebar' && <kbd className={styles.kbd}>{/Mac/.test(navigator.platform) ? '⌘K' : 'Ctrl K'}</kbd>}
        </button>
    );
    return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};

export default AskButton;
